import React from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { AboutBook } from "../components/AboutBook";
import { InsidePreview } from "../components/InsidePreview";
import { AboutAuthor } from "../components/AboutAuthor";
import { PreorderSection } from "../components/PreorderSection";
import { FAQ } from "../components/FAQ";
import { Footer } from "../components/Footer";
export function Home() {
  return <div className="min-h-screen w-full bg-ink text-cream" data-id="element-131" data-mp="1zjs43nfa2b1c">
      <Navbar data-id="element-132" data-mp="24g8w4spll9jp" />
      <main data-id="element-133" data-mp="24htpwg438ogi">
        <Hero data-id="element-134" data-mp="24hk5r95q5biq" />
        <AboutBook data-id="element-135" data-mp="24j4u2h1g3y85" />
        <InsidePreview data-id="element-136" data-mp="29g51ava1770u" />
        <AboutAuthor data-id="element-137" data-mp="29fvhjpfkxw3l" />
        <PreorderSection data-id="element-138" data-mp="29fbww0yjotlv" />
        <FAQ data-id="element-139" data-mp="29i7z41hfe4g4" />
      </main>
      <Footer data-id="element-140" data-mp="2dhgsv6cgu2bo" />
    </div>;
}